import { BASE_PATH as i, BaseAPI as L, operationServerMap as h } from "../base.js";
import { DUMMY_BASE_URL as p, assertParamExists as V, createRequestFunction as v, serializeDataIfNeeded as B, setSearchParams as y, toPathString as W } from "../common.js";
import O from "axios";
var P = function(a) {
  return {
    merchantWmsItemCostCardCreateCostCard: async (s, r = {}) => {
      V("merchantWmsItemCostCardCreateCostCard", "merchantPackageItemCostCardDTO", s);
      const m = new URL("/merchant/wms/costCard/packageItem", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", y(m, n);
      let d = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...r.headers
      }, e.data = B(s, e, a), {
        url: W(m),
        options: e
      };
    },
    merchantWmsItemCostCardCreateCostCardByItem: async (s, r = {}) => {
      V("merchantWmsItemCostCardCreateCostCardByItem", "itemCostCardImportDTO", s);
      const m = new URL("/merchant/wms/costCard/item/import", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", y(m, n);
      let d = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...r.headers
      }, e.data = B(s, e, a), {
        url: W(m),
        options: e
      };
    },
    merchantWmsItemCostCardCreateCostCard_1: async (s, r = {}) => {
      V("merchantWmsItemCostCardCreateCostCard_1", "merchantWmsItemCostCardVO", s);
      const m = new URL("/merchant/wms/costCard/ordinaryItem", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", y(m, n);
      let d = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...r.headers
      }, e.data = B(s, e, a), {
        url: W(m),
        options: e
      };
    },
    merchantWmsItemCostCardGetItemLast15DaysInfo: async (s = {}) => {
      const r = new URL("/merchant/wms/costCard/item_last_15_days_info", p);
      let m;
      a && (m = a.baseOptions);
      const t = {
        method: "GET",
        ...m,
        ...s
      }, e = {};
      y(r, {});
      let o = m && m.headers ? m.headers : {};
      return t.headers = {
        ...e,
        ...o,
        ...s.headers
      }, {
        url: W(r),
        options: t
      };
    },
    merchantWmsItemCostCardGetItemList: async (s, r = {}) => {
      V("merchantWmsItemCostCardGetItemList", "itemCategoryId", s);
      const m = "/merchant/wms/costCard/itemList/{itemCategoryId}".replace("{itemCategoryId}", encodeURIComponent(String(s))), t = new URL(m, p);
      let e;
      a && (e = a.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...r
      }, n = {};
      y(t, {});
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...d,
        ...r.headers
      }, {
        url: W(t),
        options: o
      };
    },
    merchantWmsItemCostCardGetItemListByFields: async (s, r, m, t, e = {}) => {
      V("merchantWmsItemCostCardGetItemListByFields", "shopId", s);
      const o = "/merchant/wms/costCard/itemListByFields/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), n = new URL(o, p);
      let d;
      a && (d = a.baseOptions);
      const C = {
        method: "GET",
        ...d,
        ...e
      }, l = {}, c = {};
      r !== void 0 && (c.page = r), m !== void 0 && (c.size = m), t !== void 0 && (c.fields = t), y(n, c);
      let u = d && d.headers ? d.headers : {};
      return C.headers = {
        ...l,
        ...u,
        ...e.headers
      }, {
        url: W(n),
        options: C
      };
    },
    merchantWmsItemCostCardGetItemListByFieldsV2: async (s, r, m, t, e, o = {}) => {
      const n = new URL("/merchant/wms/costCard/itemListByFieldsV2", p);
      let d;
      a && (d = a.baseOptions);
      const C = {
        method: "GET",
        ...d,
        ...o
      }, l = {}, c = {};
      s !== void 0 && (c.page = s), r !== void 0 && (c.size = r), m !== void 0 && (c.fields = m), t !== void 0 && (c.startTime = t instanceof Date ? t.toISOString() : t), e !== void 0 && (c.endTime = e instanceof Date ? e.toISOString() : e), y(n, c);
      let u = d && d.headers ? d.headers : {};
      return C.headers = {
        ...l,
        ...u,
        ...o.headers
      }, {
        url: W(n),
        options: C
      };
    },
    merchantWmsItemCostCardGetItemListV2: async (s, r = {}) => {
      V("merchantWmsItemCostCardGetItemListV2", "itemCategoryId", s);
      const m = "/merchant/wms/costCard/itemList/V2/{itemCategoryId}".replace("{itemCategoryId}", encodeURIComponent(String(s))), t = new URL(m, p);
      let e;
      a && (e = a.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...r
      }, n = {};
      y(t, {});
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...d,
        ...r.headers
      }, {
        url: W(t),
        options: o
      };
    },
    merchantWmsItemCostCardGetItemTotal: async (s, r, m = {}) => {
      const t = new URL("/merchant/wms/costCard/item_total", p);
      let e;
      a && (e = a.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...m
      }, n = {}, d = {};
      s !== void 0 && (d.startTime = s instanceof Date ? s.toISOString() : s), r !== void 0 && (d.endTime = r instanceof Date ? r.toISOString() : r), y(t, d);
      let C = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...C,
        ...m.headers
      }, {
        url: W(t),
        options: o
      };
    },
    merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId: async (s, r = {}) => {
      V("merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId", "itemId", s);
      const m = "/merchant/wms/costCard/ordinaryItem/{itemId}".replace("{itemId}", encodeURIComponent(String(s))), t = new URL(m, p);
      let e;
      a && (e = a.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...r
      }, n = {};
      y(t, {});
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...d,
        ...r.headers
      }, {
        url: W(t),
        options: o
      };
    },
    merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds: async (s, r = {}) => {
      V("merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds", "requestBody", s);
      const m = new URL("/merchant/wms/costCard/ordinaryItem/batch", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", y(m, n);
      let d = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...r.headers
      }, e.data = B(s, e, a), {
        url: W(m),
        options: e
      };
    },
    merchantWmsItemCostCardGetPackageItemCostCardByItemId: async (s, r = {}) => {
      V("merchantWmsItemCostCardGetPackageItemCostCardByItemId", "itemId", s);
      const m = "/merchant/wms/costCard/packageItem/{itemId}".replace("{itemId}", encodeURIComponent(String(s))), t = new URL(m, p);
      let e;
      a && (e = a.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...r
      }, n = {};
      y(t, {});
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...d,
        ...r.headers
      }, {
        url: W(t),
        options: o
      };
    },
    merchantWmsItemCostCardUpdateOrdinaryCostCard: async (s, r = {}) => {
      V("merchantWmsItemCostCardUpdateOrdinaryCostCard", "merchantWmsItemCostCardVO", s);
      const m = new URL("/merchant/wms/costCard/ordinaryItem", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...r
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", y(m, n);
      let d = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...r.headers
      }, e.data = B(s, e, a), {
        url: W(m),
        options: e
      };
    },
    merchantWmsItemCostCardUpdatePackageCostCard: async (s, r = {}) => {
      V("merchantWmsItemCostCardUpdatePackageCostCard", "merchantPackageItemCostCardDTO", s);
      const m = new URL("/merchant/wms/costCard/packageItem", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...r
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", y(m, n);
      let d = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...r.headers
      }, e.data = B(s, e, a), {
        url: W(m),
        options: e
      };
    }
  };
}, I = function(a) {
  const s = P(a);
  return {
    async merchantWmsItemCostCardCreateCostCard(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardCreateCostCard(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardCreateCostCard"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardCreateCostCardByItem(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardCreateCostCardByItem(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardCreateCostCardByItem"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardCreateCostCard_1(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardCreateCostCard_1(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardCreateCostCard_1"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardGetItemLast15DaysInfo(r) {
      var m, t;
      const e = await s.merchantWmsItemCostCardGetItemLast15DaysInfo(r), o = (m = a == null ? void 0 : a.serverIndex) !== null && m !== void 0 ? m : 0, n = (t = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetItemLast15DaysInfo"]) === null || t === void 0 || (t = t[o]) === null || t === void 0 ? void 0 : t.url;
      return (d, C) => v(e, O, i, a)(d, n || C);
    },
    async merchantWmsItemCostCardGetItemList(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardGetItemList(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetItemList"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardGetItemListByFields(r, m, t, e, o) {
      var n, d;
      const C = await s.merchantWmsItemCostCardGetItemListByFields(r, m, t, e, o), l = (n = a == null ? void 0 : a.serverIndex) !== null && n !== void 0 ? n : 0, c = (d = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetItemListByFields"]) === null || d === void 0 || (d = d[l]) === null || d === void 0 ? void 0 : d.url;
      return (u, G) => v(C, O, i, a)(u, c || G);
    },
    async merchantWmsItemCostCardGetItemListByFieldsV2(r, m, t, e, o, n) {
      var d, C;
      const l = await s.merchantWmsItemCostCardGetItemListByFieldsV2(r, m, t, e, o, n), c = (d = a == null ? void 0 : a.serverIndex) !== null && d !== void 0 ? d : 0, u = (C = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetItemListByFieldsV2"]) === null || C === void 0 || (C = C[c]) === null || C === void 0 ? void 0 : C.url;
      return (G, S) => v(l, O, i, a)(G, u || S);
    },
    async merchantWmsItemCostCardGetItemListV2(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardGetItemListV2(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetItemListV2"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardGetItemTotal(r, m, t) {
      var e, o;
      const n = await s.merchantWmsItemCostCardGetItemTotal(r, m, t), d = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, C = (o = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetItemTotal"]) === null || o === void 0 || (o = o[d]) === null || o === void 0 ? void 0 : o.url;
      return (l, c) => v(n, O, i, a)(l, C || c);
    },
    async merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardGetPackageItemCostCardByItemId(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardGetPackageItemCostCardByItemId(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardGetPackageItemCostCardByItemId"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardUpdateOrdinaryCostCard(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardUpdateOrdinaryCostCard(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardUpdateOrdinaryCostCard"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    },
    async merchantWmsItemCostCardUpdatePackageCostCard(r, m) {
      var t, e;
      const o = await s.merchantWmsItemCostCardUpdatePackageCostCard(r, m), n = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, d = (e = h["MerchantWmsItemCostCardApi.merchantWmsItemCostCardUpdatePackageCostCard"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (C, l) => v(o, O, i, a)(C, d || l);
    }
  };
}, M = function(a, s, r) {
  const m = I(a);
  return {
    merchantWmsItemCostCardCreateCostCard(t, e) {
      return m.merchantWmsItemCostCardCreateCostCard(t.merchantPackageItemCostCardDTO, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardCreateCostCardByItem(t, e) {
      return m.merchantWmsItemCostCardCreateCostCardByItem(t.itemCostCardImportDTO, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardCreateCostCard_1(t, e) {
      return m.merchantWmsItemCostCardCreateCostCard_1(t.merchantWmsItemCostCardVO, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetItemLast15DaysInfo(t) {
      return m.merchantWmsItemCostCardGetItemLast15DaysInfo(t).then((e) => e(r, s));
    },
    merchantWmsItemCostCardGetItemList(t, e) {
      return m.merchantWmsItemCostCardGetItemList(t.itemCategoryId, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetItemListByFields(t, e) {
      return m.merchantWmsItemCostCardGetItemListByFields(t.shopId, t.page, t.size, t.fields, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetItemListByFieldsV2(t = {}, e) {
      return m.merchantWmsItemCostCardGetItemListByFieldsV2(t.page, t.size, t.fields, t.startTime, t.endTime, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetItemListV2(t, e) {
      return m.merchantWmsItemCostCardGetItemListV2(t.itemCategoryId, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetItemTotal(t = {}, e) {
      return m.merchantWmsItemCostCardGetItemTotal(t.startTime, t.endTime, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId(t, e) {
      return m.merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId(t.itemId, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds(t, e) {
      return m.merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds(t.requestBody, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardGetPackageItemCostCardByItemId(t, e) {
      return m.merchantWmsItemCostCardGetPackageItemCostCardByItemId(t.itemId, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardUpdateOrdinaryCostCard(t, e) {
      return m.merchantWmsItemCostCardUpdateOrdinaryCostCard(t.merchantWmsItemCostCardVO, e).then((o) => o(r, s));
    },
    merchantWmsItemCostCardUpdatePackageCostCard(t, e) {
      return m.merchantWmsItemCostCardUpdatePackageCostCard(t.merchantPackageItemCostCardDTO, e).then((o) => o(r, s));
    }
  };
}, b = class extends L {
  merchantWmsItemCostCardCreateCostCard(a, s) {
    return I(this.configuration).merchantWmsItemCostCardCreateCostCard(a.merchantPackageItemCostCardDTO, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardCreateCostCardByItem(a, s) {
    return I(this.configuration).merchantWmsItemCostCardCreateCostCardByItem(a.itemCostCardImportDTO, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardCreateCostCard_1(a, s) {
    return I(this.configuration).merchantWmsItemCostCardCreateCostCard_1(a.merchantWmsItemCostCardVO, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetItemLast15DaysInfo(a) {
    return I(this.configuration).merchantWmsItemCostCardGetItemLast15DaysInfo(a).then((s) => s(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetItemList(a, s) {
    return I(this.configuration).merchantWmsItemCostCardGetItemList(a.itemCategoryId, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetItemListByFields(a, s) {
    return I(this.configuration).merchantWmsItemCostCardGetItemListByFields(a.shopId, a.page, a.size, a.fields, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetItemListByFieldsV2(a = {}, s) {
    return I(this.configuration).merchantWmsItemCostCardGetItemListByFieldsV2(a.page, a.size, a.fields, a.startTime, a.endTime, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetItemListV2(a, s) {
    return I(this.configuration).merchantWmsItemCostCardGetItemListV2(a.itemCategoryId, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetItemTotal(a = {}, s) {
    return I(this.configuration).merchantWmsItemCostCardGetItemTotal(a.startTime, a.endTime, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId(a, s) {
    return I(this.configuration).merchantWmsItemCostCardGetOrdinaryItemCostCardByItemId(a.itemId, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds(a, s) {
    return I(this.configuration).merchantWmsItemCostCardGetOrdinaryItemCostCardByItemIds(a.requestBody, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardGetPackageItemCostCardByItemId(a, s) {
    return I(this.configuration).merchantWmsItemCostCardGetPackageItemCostCardByItemId(a.itemId, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardUpdateOrdinaryCostCard(a, s) {
    return I(this.configuration).merchantWmsItemCostCardUpdateOrdinaryCostCard(a.merchantWmsItemCostCardVO, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsItemCostCardUpdatePackageCostCard(a, s) {
    return I(this.configuration).merchantWmsItemCostCardUpdatePackageCostCard(a.merchantPackageItemCostCardDTO, s).then((r) => r(this.axios, this.basePath));
  }
};
export {
  b as MerchantWmsItemCostCardApi,
  P as MerchantWmsItemCostCardApiAxiosParamCreator,
  M as MerchantWmsItemCostCardApiFactory,
  I as MerchantWmsItemCostCardApiFp
};

//# sourceMappingURL=merchant-wms-item-cost-card-api.js.map